import React from 'react'
import { Tabs } from '@/shared/ui'
import { useAuth } from '@/modules/auth/context/AuthContext'
import RevshareMySummaryPanel from './RevshareMySummaryPanel'
import RevshareBankAccountsManager from './RevshareBankAccountsManager'
import RevshareMyPayoutsPanel from './RevshareMyPayoutsPanel'

export default function RepassesParticipantView() {
  const { profile } = useAuth()
  const uid = profile?.id || ''
  const [tab, setTab] = React.useState<'resumo' | 'banco' | 'recebimentos'>('resumo')

  if (!uid) return null

  return (
    <div>
      <Tabs
        tabs={[
          { value: 'resumo', label: 'Resumo' },
          { value: 'banco', label: 'Dados bancarios' },
          { value: 'recebimentos', label: 'Recebimentos' },
        ]}
        value={tab}
        onValueChange={(v) => setTab(v as any)}
        className="mb-6"
      />

      {tab === 'resumo' && <RevshareMySummaryPanel userId={uid} />}
      {tab === 'banco' && <RevshareBankAccountsManager />}
      {tab === 'recebimentos' && <RevshareMyPayoutsPanel />}
    </div>
  )
}

